import React, {
  ReactNode,
} from 'react';
import clsx from 'clsx';
import MuiAccordion, {
  AccordionProps,
} from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

type Props = AccordionProps & {
  header: ReactNode;
  headerActions?: ReactNode;
  className?: string;
  detailsClasses?: Record<string, string>;
  headerClasses?: Record<string, string>;
  disabled?: boolean;
  expandIcon?: ReactNode;
  children: ReactNode;
};

export default function Accordion({
  header,
  headerActions,
  children,
  className,
  detailsClasses,
  headerClasses,
  disabled,
  expandIcon = <ExpandMoreIcon />,
  ...props
}: Props) {
  const classes = clsx(
    'populate-accordion',
    { '!bg-transparent !pointer-events-none': disabled },
    className,
  );

  return (
    <MuiAccordion
      disabled={disabled}
      className={classes}
      {...props}
    >
      <div className="relative">
        <AccordionSummary
          // Keep the summary root as a div because `headerActions` can render
          // interactive controls, and the default button root creates nested
          // button markup plus console errors. The keyword accessibility is working as intended.
          component="div"
          expandIcon={expandIcon}
          classes={headerClasses}
        >
          {header}
        </AccordionSummary>
        {headerActions && (
          <div className="absolute inset-y-0 right-10 z-10 flex items-center gap-2 pointer-events-auto">
            {headerActions}
          </div>
        )}
      </div>
      <AccordionDetails classes={detailsClasses}>
        {children}
      </AccordionDetails>
    </MuiAccordion>

  );
}
